<template>
	<div class="distributor-bank-list">
		<div class="common-header-wrap">
			<mt-header :title="$t('Withdrawal Accounts')" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>
		<div class="pb-30" v-if="bank_list.length > 0">
			<div class="mb-5" v-for="item in bank_list" :key="item.bank_id" v-if="item.memberbank_id > 0">
				<div class="container">
					<div class="top-wrapper">
						<div class="title-wrapper">
							<label class="title">{{ item.memberbank_name }}</label>
							<label class="title">{{ item.memberbank_truename }}</label>
						</div>
						<label class="desc bank-text">{{ memberbankTypeText(item.memberbank_type) }}&nbsp;{{
							item.memberbank_no }}</label>
						<div class="bottom-line"></div>
					</div>
					<!-- <div class="bottom-wrapper">
						<div class="bottom-right-wrapper">
							<div class="edit-wrapper" @click="onEdit(item.memberbank_id)">
								<div class="common-btn btn-2 mr-5">{{ $t('Edit') }}</div>
							</div>
							<div class="edit-wrapper delete-wrapper" @click="onDelete(item.memberbank_id)">
								<div class="common-btn btn-1">{{ $t('Delete') }}</div>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<div v-else>
			<empty-record></empty-record>
		</div>
		<div class='common-add-btn-wrapper' v-if="btnShow">
			<div class="div common-btn common-add-btn" @click="goAdd">{{ $t('Add New') }}</div>
		</div>
	</div>
</template>
<script>

import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getBankList, delBank } from '../../../api/memberBank'
export default {
	components: {
		EmptyRecord
	},
	name: 'MemberBankList',
	data() {
		return {
			bank_list: [],
			btnShow: false,
		}
	},
	computed: {
		memberbankTypeText() {
			return function (memberbankType) {
				if (memberbankType === 'bank') {
					return 'bank'
				} else if (memberbankType === 'alipay') {
					return 'alipay'
				} else {
					return 'USDT'
				}
			}
		}
	},
	created: function () {
		this.getBankList()
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		goAdd() {
			this.$router.push({ name: 'MemberBankForm', query: { action: 'add' } })
		},
		onEdit(memberbankId) {
			this.$router.push({ name: 'MemberBankForm', query: { memberbank_id: memberbankId } })
		},
		onDelete(memberbankId) {
			let that = this
			MessageBox({
				title: that.$t('MessageBox.Tips'),
				message: that.$t('MessageBox.delete.bank'),
				confirmButtonText: that.$t('MessageBox.Confirm'),
				cancelButtonText: that.$t('MessageBox.Cancel'),
				showCancelButton: true
			}).then(action => {
				if (action == 'confirm') {
					Indicator.open()
					delBank(memberbankId).then(
						(response) => {
							this.getBankList()
							Indicator.close()
						}, (error) => {
							Indicator.close()
							Toast(error.message)
						})
				}
			});

		},
		getBankList() {
			getBankList().then(res => {
				this.bank_list = res.result.bank_list
				if (this.bank_list.length > 0) {
					this.btnShow = false
				} else {
					this.btnShow = true
				}
			}).catch(function (error) {
				Toast(error.message)
			})
		}
	}
}
</script>
<style  lang="scss" scoped>
.distributor-bank-list {
	.common-header {
		.btn {
			background: #000;
			color: #fff;
			box-shadow: 0px 2px 4px #d2d2d2;
		}
	}

	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		background-color: #fff;
	}

	.btn-1 {
		border: 1px solid $primaryColor;
		color: $primaryColor;
		min-width: 2rem
	}

	.btn-2 {
		border: 1px solid #333;
		color: #333;
		min-width: 2rem
	}

	.top-wrapper {
		position: relative;
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
	}

	.title-wrapper {
		height: 1rem;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin-top: 0.5rem;
		margin-left: 0.5rem;
	}

	.title {
		font-size: $h3;
		color: #333;
		font-weight: 700;
		margin-left: 0.5rem;
	}

	.default {
		width: 1.4rem;
		margin-left: 0.5rem;
		margin-right: 0.5rem;
		border: 1px solid $primaryColor;
		color: $primaryColor;
		font-size: $h6;
		text-align: center;
		border-radius: 0.1rem;
	}

	.desc {
		color: $descTextColor;
		font-size: $subFontSize;
	}

	.bank-text {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
		margin-left: 1rem;
		margin-right: 0.5rem;
	}

	.bottom-line {
		position: absolute;
		left: 0.5rem;
		bottom: 0;
		right: 0.5rem;
		border-bottom: 1px dashed #eee
	}

	.bottom-wrapper {
		height: 2.5rem;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: stretch;
	}

	.bottom-right-wrapper {
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: stretch;
	}

	.edit-wrapper {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.delete-wrapper {
		margin-right: 0.5rem;
	}

	.indicator {
		width: 1rem;
		height: 1rem;
		margin-left: 0.75rem;
		margin-right: 0.5rem;
		font-size: $subFontSize;
	}

	.icon {
		width: 0.9rem;
		height: 0.9rem;
		margin-left: 0.5rem;
	}

	.subtitle {
		font-size: $subFontSize;
		color: #7c7f88;
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
		margin-left: 1rem;
		margin-right: 0.5rem;
	}

	.subtitle i {
		font-size: $h2;
		margin-right: .5rem;
	}
}
</style>
